module.exports = __webpack_public_path__ + "static/media/faq_image@3x.ef1a2f98.png";